const STORAGE_KEY_PREFIX = "guest_profile_prompt_dismissed";

export function getGuestProfilePromptStorageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}:${userId}`;
}

function isLocalStorageAvailable(): boolean {
  if (typeof window === "undefined") return false;

  try {
    const probe = "__guest_profile_prompt_storage_probe__";
    localStorage.setItem(probe, probe);
    localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

export function hasGuestOptionalProfilePromptBeenShown(
  userId: string | undefined | null
): boolean {
  if (!userId || !isLocalStorageAvailable()) return false;

  try {
    return (
      localStorage.getItem(getGuestProfilePromptStorageKey(userId)) === "1"
    );
  } catch {
    return false;
  }
}

export function markGuestOptionalProfilePromptShown(
  userId: string | undefined | null
): void {
  if (!userId || !isLocalStorageAvailable()) return;

  try {
    localStorage.setItem(getGuestProfilePromptStorageKey(userId), "1");
  } catch {
    // Storage blocked — no-op; the prompt may appear again on next contribution.
  }
}

export function clearGuestOptionalProfilePromptShown(
  userId: string | undefined | null
): void {
  if (!userId || !isLocalStorageAvailable()) return;

  localStorage.removeItem(getGuestProfilePromptStorageKey(userId));
}

export function clearGuestProfilePromptDismissedIfNoActiveGuestSession(
  isLoggedIn: boolean,
  profile: { guest?: boolean } | undefined | null
): void {
  const hasActiveGuestSession = isLoggedIn && !!profile?.guest;
  if (hasActiveGuestSession || !isLocalStorageAvailable()) return;

  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(`${STORAGE_KEY_PREFIX}:`)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
